'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var ToggleableContext = require('../alloy-toggleable/ToggleableContext.js');
var stepper_module = require('./stepper.module.scss.js');

var Step = function (_a) {
    var children = _a.children, _b = _a.order, order = _b === void 0 ? 0 : _b, onClick = _a.onClick, _c = _a.stepperDisabled, stepperDisabled = _c === void 0 ? false : _c, props = tslib.__rest(_a, ["children", "order", "onClick", "stepperDisabled"]);
    var ctx = react.useContext(ToggleableContext.default);
    var isPreviousStep = ctx.activeChildren > order;
    var isActive = ctx.isActive(order);
    var handleClick = function (e) {
        ctx.toggleActive(order);
        if (onClick) {
            onClick(e);
        }
    };
    return (jsxRuntime.jsxs("li", tslib.__assign({ className: "".concat(stepper_module.default.step, " ").concat((isActive && !stepperDisabled) ? stepper_module.default.active : '') }, props, { children: [jsxRuntime.jsx("div", { className: stepper_module.default.dot }), jsxRuntime.jsx("div", tslib.__assign({ className: "text-center" }, { children: react.Children.map(children, function (child) {
                    return react.cloneElement(child, !stepperDisabled ? {
                        isActive: isPreviousStep,
                        onClick: !stepperDisabled ? handleClick : undefined
                    } : {});
                }) }))] })));
};
var Step$1 = react.memo(Step);

exports.default = Step$1;
//# sourceMappingURL=Step.js.map
